import styled from 'styled-components';
import { StatusNotify, StatusToolsProps } from '../../common/interfaces';
import { ToolsConditionStatusColor } from '../../components/enum/toolsStatusEnum';

export {
    Container,
    Title,
    TableContainer,
    Pagination,
    ActionButton,
    Table,
    ActionsCell,
    TextFeldClientSearch,
    SearchCard as SchedulingSearchCard,
} from '../sharedTable.styled';

export const StatusToolsCell = styled.td<StatusToolsProps>`
  color: ${({ status }) => ToolsConditionStatusColor[status] || 'var(--text)'};
  font-weight: 700;
`;

export const StatusMyNotify = styled.td<StatusNotify>`
  color: ${({ status }) => (status ? '#34d399' : 'var(--accent-rose)')};
  font-weight: 700;
`;
